module.exports = __webpack_public_path__ + "static/media/jardines06.1fa5b12b.jpg";